import axios from "axios";

// Interceptor para redireccionar al login si la sesión ha expirado
axios.interceptors.response.use(
    response => response,
    function (error) {
        const res = error.response;

        if (res && res.status === 401 && res.data.message === 'Unauthenticated') {
            window.location.href = '/';
        }

        return Promise.reject(error);
    }
);

const apiClient = {
    get(url, config = {}) {
        return axios.get(url, config)
    },

    post(url, data, config = {}) {
        return axios.post(url, data, config);
    },

    put(url, data, config = {}) {
        return axios.put(url, data, config);
    },

    patch(url, data, config = {}) {
        return axios.patch(url, data, config);
    },

    delete(url, config = {}) {
        return axios.delete(url, config);
    },
};

export default apiClient;
